export var RelType;
(function (RelType) {
    RelType["PRIMARY"] = "http://ns.adobe.com/adobecloud/rel/primary";
    RelType["ID"] = "http://ns.adobe.com/adobecloud/rel/id";
    RelType["PATH"] = "http://ns.adobe.com/adobecloud/rel/path";
    RelType["RENDITION"] = "http://ns.adobe.com/adobecloud/rel/rendition";
    RelType["COMPONENT_RENDITION"] = "http://ns.adobe.com/adobecloud/rel/componentRendition";
    RelType["MANIFEST"] = "http://ns.adobe.com/adobecloud/rel/manifest";
    RelType["QUOTA"] = "http://ns.adobe.com/adobecloud/rel/quota";
    RelType["COMPONENT"] = "http://ns.adobe.com/adobecloud/rel/component";
    RelType["PAGE"] = "http://ns.adobe.com/adobecloud/rel/page";
    RelType["DISCARD"] = "http://ns.adobe.com/adobecloud/rel/discard";
    RelType["RESTORE"] = "http://ns.adobe.com/adobecloud/rel/restore";
    RelType["DIRECTORY"] = "http://ns.adobe.com/adobecloud/rel/directory";
    RelType["DIRECTORY_BASE"] = "http://ns.adobe.com/adobecloud/rel/directory/base";
    RelType["AC_EFFECTIVE"] = "http://ns.adobe.com/adobecloud/rel/ac/effective";
    RelType["AC_POLICY"] = "http://ns.adobe.com/adobecloud/rel/ac/policy";
    RelType["AC_CHECK"] = "http://ns.adobe.com/adobecloud/rel/ac/check";
    RelType["CREATE"] = "http://ns.adobe.com/adobecloud/rel/create";
    RelType["REPOSITORY"] = "http://ns.adobe.com/adobecloud/rel/repository";
    RelType["RESOLVE_ID"] = "http://ns.adobe.com/adobecloud/rel/resolve/id";
    RelType["RESOLVE_PATH"] = "http://ns.adobe.com/adobecloud/rel/resolve/path";
    RelType["OPS"] = "http://ns.adobe.com/adobecloud/rel/ops";
    RelType["BLOCK_INITIALIZE"] = "http://ns.adobe.com/adobecloud/rel/block/init";
    RelType["BLOCK_TRANSFER"] = "http://ns.adobe.com/adobecloud/rel/block/transfer";
    RelType["BLOCK_FINALIZE"] = "http://ns.adobe.com/adobecloud/rel/block/finalize";
    RelType["REPO_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/repository";
    RelType["APP_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/application";
    RelType["EMBEDDED_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/embedded";
    RelType["PERUSER_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/peruser";
    RelType["ANNOTATIONS"] = "http://ns.adobe.com/adobecloud/rel/annotations";
    RelType["DOWNLOAD"] = "http://ns.adobe.com/adobecloud/rel/download";
    RelType["DESCRIBED_BY"] = "describedBy";
    RelType["VERSION"] = "version-history";
    RelType["SUBSCRIPTION_CREATE"] = "subscription/create";
    RelType["NOTIFICATIONS_LONGPOLL"] = "notifications/longpoll";
    RelType["ONS_CHANGELOG"] = "ons/changelog";
    RelType["REPOSITORIES_PAGE"] = "http://ns.adobe.com/repositories/rel/page";
    RelType["TEAMS_CREATE"] = "http://ns.adobe.com/teams/rel/create";
    RelType["TEAMS_DISCARD"] = "http://ns.adobe.com/teams/rel/discard";
    RelType["TEAMS_RESTORE"] = "http://ns.adobe.com/teams/rel/restore";
    RelType["TEAMS_RENAME"] = "http://ns.adobe.com/teams/rel/rename";
    RelType["TEAMS_PROPERTIES"] = "http://ns.adobe.com/teams/rel/properties";
    RelType["TEAMS_PAGE"] = "http://ns.adobe.com/teams/rel/page";
    RelType["TEAMS_PRIMARY"] = "http://ns.adobe.com/teams/rel/primary";
    RelType["TEAM_PROVISION"] = "http://ns.adobe.com/teams/rel/provision";
    RelType["WORKSPACES_CONTEXT"] = "http://ns.adobe.com/ccprojects/rel/context";
    RelType["WORKSPACES_BOOKMARKS_BATCH"] = "http://ns.adobe.com/ccprojects/rel/bookmarks/batch";
    RelType["WORKSPACES_PRIMARY"] = "http://ns.adobe.com/ccprojects/rel/primary";
    RelType["WORKSPACES_CREATE"] = "http://ns.adobe.com/ccprojects/rel/create";
    RelType["WORKSPACES_PAGE"] = "http://ns.adobe.com/ccprojects/rel/page";
    RelType["PROJECTS_LIBRARIES_PAGE"] = "http://ns.adobe.com/ccprojects/rel/libraries/page";
    RelType["PROJECTS_LIBRARIES_CREATE"] = "http://ns.adobe.com/ccprojects/rel/libraries/create";
    RelType["PROJECTS_LIBRARIES_BATCH"] = "http://ns.adobe.com/ccprojects/rel/libraries/batch";
    RelType["GENERIC_PAGE"] = "page";
    RelType["GENERIC_NEXT"] = "next";
    RelType["ATS_MOVE"] = "http://ns.adobe.com/ats/rel/move";
    RelType["REVIEW_SERVICE_PROVISION"] = "http://ns.adobe.com/ccassetreview/rel/provision";
    RelType["REVIEW_SERVICE_DISCARD"] = "http://ns.adobe.com/ccassetreview/rel/discard";
    RelType["REVIEW_SERVICE_OUTPUTS"] = "http://ns.adobe.com/ccassetreview/rel/outputs";
    RelType["REVIEW_SERIVCE_HAS_OUTPUTS"] = "http://ns.adobe.com/ccassetreview/rel/hasoutputs";
    RelType["PROJECTS_CONTEXT"] = "http://ns.adobe.com/projects/rel/context";
    RelType["PROJECTS_PRIMARY"] = "http://ns.adobe.com/projects/rel/primary";
    RelType["PROJECTS_COLLECTION"] = "http://ns.adobe.com/projects/rel/collection";
    RelType["PROJECTS_CREATE"] = "http://ns.adobe.com/projects/rel/create";
    RelType["PROJECTS_RENAME"] = "http://ns.adobe.com/projects/rel/rename";
    RelType["PROJECTS_CREATOR"] = "http://ns.adobe.com/projects/rel/creator";
    RelType["PROJECTS_GRADIENTS_COLLECTION"] = "http://ns.adobe.com/gradients/rel/collection";
    RelType["PROJECTS_CAPABILITY"] = "http://ns.adobe.com/projects/rel/capability";
    RelType["ORGANIZATIONS_COLLECTION"] = "http://ns.adobe.com/organizations/rel/collection";
    RelType["PROJECTS_RECENT"] = "http://ns.adobe.com/projects/rel/recent";
    RelType["PROJECTS_REFERENCE_CREATE"] = "http://ns.adobe.com/projects/rel/references/create";
    RelType["PROJECTS_REFERENCE_PRIMARY"] = "http://ns.adobe.com/projects/rel/references/primary";
    RelType["ASSIGNMENTS_ASSIGN"] = "http://ns.adobe.com/assignments/rel/assign";
    RelType["ASSIGNMENTS_CODE"] = "http://ns.adobe.com/assignments/rel/code";
    RelType["ASSIGNMENTS_COLLECTION"] = "http://ns.adobe.com/assignments/rel/collection";
    RelType["ASSIGNMENTS_CREATE"] = "http://ns.adobe.com/assignments/rel/create";
    RelType["ASSIGNMENTS_PRIMARY"] = "http://ns.adobe.com/assignments/rel/primary";
    RelType["ASSIGNMENTS_RETURN"] = "http://ns.adobe.com/assignments/rel/return";
    RelType["ASSIGNMENTS_START"] = "http://ns.adobe.com/assignments/rel/start";
    RelType["ASSIGNMENTS_SUBMIT"] = "http://ns.adobe.com/assignments/rel/submit";
    RelType["STUDENT_ASSIGNMENTS_COLLECTION"] = "http://ns.adobe.com/studentAssignments/rel/collection";
    RelType["STUDENT_ASSIGNMENTS_PRIMARY"] = "http://ns.adobe.com/studentAssignments/rel/primary";
})(RelType || (RelType = {}));
